export type InsideSpaceCardsLayout = 'grid' | 'stack';

/** Responsive grid for link cards (1 column on narrow viewports, 3 on md+). */
export const insideSpaceCardsGridClassName = 'm-0 grid grid-cols-1 gap-4 p-0 md:grid-cols-3 md:gap-6 [&>*]:min-w-0';

/** Single-column stack for link cards (e.g. burger menu drawer). */
export const insideSpaceCardsStackClassName = 'm-0 grid grid-cols-1 gap-4 p-0 [&>*]:min-w-0';

export function getInsideSpaceCardsLayoutClassName(layout: InsideSpaceCardsLayout = 'stack'): string {
    return layout === 'stack' ? insideSpaceCardsStackClassName : insideSpaceCardsGridClassName;
}
